export default {
  firebase: {
    config: {
      apiKey: 'AIzaSyDaqXK27OgcjTyk3VNqqUJkB0Mv6mCEVew',
      authDomain: 'hdrain-tower-prod.firebaseapp.com',
      databaseURL: 'https://hdrain-tower-prod.firebaseio.com',
      projectId: 'hdrain-tower-prod',
      storageBucket: 'hdrain-tower-prod.appspot.com',
      messagingSenderId: '702996525399',
      appId: '1:702996525399:web:465ac36c5dc3bdad42ce12',
      measurementId: 'G-W368T3FEVS',
    },
  },
};
